module.exports = __webpack_public_path__ + "media/images/iconSocialFacebook__inactive-28e9eb06f25173cda453be63ba7f7c5e.png";